import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PersonIcon from '@mui/icons-material/Person';
import { GradientIcon } from '../gradients/GradientIcon';

export type ParticipantsWithIconProps = {
  current: number;
  max: number;
};

export function ParticipantsWithIcon({
  current,
  max,
}: ParticipantsWithIconProps) {
  return (
    <Box sx={{ display: 'flex', pr: 10 }}>
      <Typography variant="h6">{`${current}/${max}`}</Typography>
      <Box sx={{ position: 'relative', pl: 2 }}>
        <PersonIcon
          sx={{ color: '#4DC8FF', position: 'absolute', zIndex: 3 }}
        />
        <GradientIcon
          IconComponent={PersonIcon}
          gradientColor="primary.horizontal"
          sx={{
            transform: 'scale(0.9)',
            position: 'absolute',
            ml: 2.5,
            mb: 1.9,
            zIndex: 2,
          }}
        />
        <PersonIcon
          sx={{
            color: '#0064E9',
            transform: 'scale(0.75)',
            position: 'absolute',
            ml: 4.65,
            mb: 8,
            zIndex: 1,
          }}
        />
      </Box>
    </Box>
  );
}
